<template>
  <g clip-path="url(#clip0_3399_5260)">
    <path
      d="M8 9.99707V14.4971"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 5.99707V1.49707"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 3.49707L8 1.49707L10 3.49707"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 12.4971L8 14.4971L10 12.4971"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 7.99707H1.5"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 7.99707H14.5"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 5.99707L14.5 7.99707L12.5 9.99707"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.5 5.99707L1.5 7.99707L3.5 9.99707"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_3399_5260">
      <rect
        width="16"
        height="16"
        fill="white"
        transform="translate(0 -0.00292969)"
      />
    </clipPath>
  </defs>
</template>
